import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import FuelSupplyForm from '../Forms/FuelSupplyForm';
import SetBalanceSupplyForm from '../Forms/SetBalanceSupplyForm';

const SetBalanceFuelSupplyModal = ({
	establishment_id,
	dataFuelSupply,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Ajuste de Saldo Inicio de Mes
			</ModalHeader>

			<SetBalanceSupplyForm
				establishment_id={establishment_id}
				dataFuelSupply={dataFuelSupply}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
		</Modal>
	);
};

export default SetBalanceFuelSupplyModal;
